export default "__VITE_ASSET__CRUPB8h___"